import { GivelifyLabel } from '@givelify/ui';
import { Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Content = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    flexDirection: 'column',
}));

export const MainBox = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    padding: theme.spacing(4),
    paddingTop: 0,
    [theme.breakpoints.down('mobile')]: {
        padding: 0,
    },
}));

export const Illustration = styled('img')({
    margin: '41px auto 19px auto',
});

export const SectionTitle = styled(GivelifyLabel)(({ theme }) => ({
    marginBottom: 16,
    [theme.breakpoints.down('xs')]: {
        marginBottom: 8,
    },
}));

export const TextDivider = styled(Divider)(({ theme }) => ({
    marginTop: 32,
    marginBottom: 32,
    width: '100%',
    [theme.breakpoints.down('xs')]: {
        marginTop: 8,
        marginBottom: 8,
    },
}));
